module.exports = __webpack_public_path__ + "img/font_title.5417dc19.png";